module.exports = __webpack_public_path__ + "img/icon_4.4ec9d965.png";